/// <reference types="react-scripts" />
import { List } from "@mui/material";
import * as React from "react";
import { CardContainer } from "../../framework/CardContainer";
import { IFrontToDoItems } from "../../../models/front/frontToDoItems";
import { DashboardCardTitle } from "../../framework/DashboardCard/DashboardCardTitle";
import { DashboardCardProgress } from "../DashboardCard/DashboardCardProgress";
import { IFrontToDoItem } from "source/models/front/frontToDoItem";
import { DashboardToDoItem } from "./DashboardToDoItem";

export interface IDashboardStatisticsProp {
    loading: boolean;
    title: string;
    toDoItems: IFrontToDoItems;
    onClick: (toDoItem: IFrontToDoItem) => void;
}

export const DashboardStatistics = (props: IDashboardStatisticsProp) => {
    const handleStatisticsClick = (e: any, toDoItem: IFrontToDoItem) => {
        e.stopPropagation();
        props.onClick(toDoItem);
    };

    const toDoItems = props.toDoItems;
    return (
        <>
            <DashboardCardTitle
                title={props.title}
            />
            <CardContainer>
                <DashboardCardProgress isLoading={props.loading} />
                <List>
                    {!!toDoItems && toDoItems.items.map(item =>
                        <DashboardToDoItem key={item.title} toDoItem={item} onClick={handleStatisticsClick} />
                    )}
                </List>
            </CardContainer>
        </>
    );
};